import {createSubmitRequestTypes} from "./helpers";

export const REQUEST_START_DELIVERY = "SUBSCRIPTION:REQUEST_START_DELIVERY";
export const START_DELIVERY = createSubmitRequestTypes("SUBSCRIPTION:START_DELIVERY");
export const requestStartDelivery = (deliveryId) => ({ type: REQUEST_START_DELIVERY, deliveryId });
export const cancelStartDelivery = () => ({ type: START_DELIVERY.CANCEL });

export const REQUEST_RETRY_STOCK_RESERVATION = "SUBSCRIPTION:REQUEST_RETRY_STOCK_RESERVATION";
export const RETRY_STOCK_RESERVATION = createSubmitRequestTypes("SUBSCRIPTION:RETRY_STOCK_RESERVATION");
export const requestRetryStockReservation = (deliveryId) => ({ type: REQUEST_RETRY_STOCK_RESERVATION, deliveryId });
export const cancelRetryStockReservation = () => ({ type: RETRY_STOCK_RESERVATION.CANCEL });

export const REQUEST_CHANGE_STOCK_RESERVATION_WAREHOUSE = "SUBSCRIPTION:REQUEST_CHANGE_STOCK_RESERVATION_WAREHOUSE";
export const CHANGE_STOCK_RESERVATION_WAREHOUSE = createSubmitRequestTypes("SUBSCRIPTION:CHANGE_STOCK_RESERVATION_WAREHOUSE");
export const requestChangeStockReservationWarehouse = (deliveryId) => ({ type: REQUEST_CHANGE_STOCK_RESERVATION_WAREHOUSE, deliveryId });
export const cancelChangeStockReservationWarehouse = () => ({ type: CHANGE_STOCK_RESERVATION_WAREHOUSE.CANCEL });

export const REQUEST_RETRY_SCHEDULING = "SUBSCRIPTION:REQUEST_RETRY_SCHEDULING";
export const RETRY_SCHEDULING = createSubmitRequestTypes("SUBSCRIPTION:RETRY_SCHEDULING");
export const requestRetryScheduling = (deliveryId) => ({ type: REQUEST_RETRY_SCHEDULING, deliveryId });
export const cancelRetryScheduling = () => ({ type: RETRY_SCHEDULING.CANCEL });

